import React from "react";
import styled from "styled-components";
import { Text, Flex, Box } from "rebass";

import User from "../Users/User";

type Props = {
  src: string,
  message: string
};

const MessengerBubble = ({
  src = "https://randomuser.me/api/portraits/women/65.jpg",
  message = "Hello Sarah"
}: Props) => (
  <Greeting>
    <Flex>
      <Box pr={["10px"]}>
        <User src={src} />
      </Box>
      <Box>
        <ChatBubble>{message}&hellip;</ChatBubble>
      </Box>
    </Flex>
  </Greeting>
);

export default MessengerBubble;

// Styled Components
const Greeting = styled.div`
  background: #ffffff;
  border-radius: 15px;
  border: 1px solid rgba(151, 151, 151, 0.06);
  box-shadow: 1px 1px 1px 0 rgba(255, 255, 255, 0.59),
    inset 1px 1px 3px 0 rgba(0, 0, 0, 0.07);
  display: inline-block;
  height: 60px;
  padding: 10px;
`;

const ChatBubble = styled(Text)`
  background: #f1f0f0;
  border-radius: 17.86px;
  color: #000000;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 16px;
  height: 40px;
  letter-spacing: -0.42px;
  line-height: 40px;
  padding: 0 15px;
`;



// WEBPACK FOOTER //
// ./src/components/ui/MessengerBubble.jsx